import React from "react";
import { H2, SystemMessage, Text } from "@shoptet/ui";
import { Trans, useTranslation } from "react-i18next";
import { Accordion } from "../../elements/Accordion";
import { Deactivate } from "../../elements/AdvancedSetup/Deactivate";
import { ExcludeProducts } from "../../elements/AdvancedSetup/ExcludeProducts";
import { AdSystemT, useAdSystemCampaignStateQuery, useProductExclusionQuery } from "../../graphql/generated/graphql";
import { getAdSystemCampaignState } from "../../utils/getAdSystemCampaignState";

const MetaSettings = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Settings Page" });
  const { data: campaignStateData } = useAdSystemCampaignStateQuery({
    variables: {
      adSystem: AdSystemT.MetaAdsT,
      dateTo: new Date().toISOString().split("T")[0],
    },
  });

  const { data: productExclusionData } = useProductExclusionQuery({
    variables: { adSystem: AdSystemT.MetaAdsT },
  });
  const campaignState = getAdSystemCampaignState(campaignStateData, AdSystemT.MetaAdsT);
  const totalProducts = productExclusionData?.organization?.productsCount || 0;
  const bannedProducts = productExclusionData?.organization?.bannedProductsCount || 0;
  const hasMostlyBannedProducts = totalProducts > 0 && (bannedProducts / totalProducts) * 100 > 90;
  return (
    <div>
      <div style={{ marginBottom: "24px " }}>
        <H2>{t("Meta settings")}</H2>
      </div>
      <div style={{ marginBottom: "24px" }}>
        <Accordion defaultOpened={hasMostlyBannedProducts} header={t("Products in campaign")}>
          <SystemMessage
            level="alert"
            description={
              <Text>
                <Trans components={{ b: <b /> }} i18nKey="Update Products WarningBox" t={t} />
              </Text>
            }
          />
          <ExcludeProducts adSystem={AdSystemT.MetaAdsT} />
        </Accordion>
      </div>
      {campaignState !== "wizard" && <Deactivate adSystem={AdSystemT.MetaAdsT} />}
    </div>
  );
};

export default MetaSettings;
